"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const CompactWorkItemHeader_1 = __importDefault(require("@Components/WorkItemV2/Catalog/CompactWorkItemHeader"));
const CatalogCompactWorkItemHeader = () => (react_1.default.createElement(CompactWorkItemHeader_1.default, null,
    react_1.default.createElement("span", { className: 'label-with-tooltip' },
        "Share Amounts",
        react_1.default.createElement(CustomToolTip_1.default, { info: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("b", null, "Your Shares:"),
                " This represents the total shares you have claimed on this work.",
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("b", null, "Total Known Shares:"),
                " This reflects total claimed shares on this work by all parties. If part of these shares is unknown, the total will be less than 100%."), inverse: true, type: '?' }))));
exports.default = CatalogCompactWorkItemHeader;
